module.exports = __webpack_public_path__ + "static/media/avisoprivacidad.432cbd2b.svg";